const STAFF = ["admin", "superadmin", "local_admin"];
const FULL_ADMIN = ["admin", "superadmin"];

const routes = [
  {
    path: "databases",
    component: () =>
      import(/* webpackChunkName: "admin" */ "views/Database/TableList.vue"),
    name: "database_list",
    meta: { role: STAFF },
  },
  {
    path: "databases/:id/edit",
    component: () =>
      import(/* webpackChunkName: "admin" */ "views/Database/Edit.vue"),
    name: "database_edit",
    meta: { role: FULL_ADMIN },
    children: [
      {
        path: ":groupId",
        component: () =>
          import(/* webpackChunkName: "admin" */ "views/Group/Edit.vue"),
        name: "group_edit",
        meta: { role: FULL_ADMIN },
      },
    ],
  },
  {
    path: "subscription_requests",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "views/SubscriptionRequest/TableList.vue"
      ),
    name: "request_list",
    meta: { role: STAFF },
  },
  {
    path: "users",
    component: () =>
      import(/* webpackChunkName: "admin" */ "views/User/TableList.vue"),
    name: "user_list",
    meta: { role: STAFF },
  },
  {
    path: "databases/:id",
    component: () =>
      import(/* webpackChunkName: "admin" */ "views/Database/Show.vue"),
    name: "database_show",
    meta: { role: STAFF },
  },
  // Tabs of the database page: same component, another section.
  {
    path: "databases/:id/users",
    component: () =>
      import(/* webpackChunkName: "admin" */ "views/Database/Show.vue"),
    name: "database_users",
    meta: { role: STAFF },
  },
  {
    path: "databases/:id/settings",
    component: () =>
      import(/* webpackChunkName: "admin" */ "views/Database/Show.vue"),
    name: "database_settings",
    meta: { role: FULL_ADMIN },
  },
  // --- TEMPLATE ADMIN ---
  {
    path: "databases/:databaseId/templates",
    component: () => import("views/Template/TableList.vue"),
    name: "admin_templates_list",
    meta: { role: FULL_ADMIN },
  },
  // --- STATISTICHE ADMIN ---
  {
    path: "databases/:databaseId/stats",
    component: () => import("views/Stats/Index.vue"),
    name: "admin_stats_index",
    meta: { role: STAFF },
  },
  {
    path: "databases/:databaseId/stats/:templateId",
    component: () => import("views/Stats/Show.vue"),
    name: "admin_stats_show",
    meta: { role: STAFF },
  },
  {
    path: "databases/:databaseId/stats/:templateId/config",
    component: () => import("views/Template/Config.vue"),
    name: "admin_template_config",
    meta: { role: FULL_ADMIN },
  },
];

export default routes;
